import { render, staticRenderFns } from "./creditwait.vue?vue&type=template&id=6b163464&"
import script from "./creditwait.vue?vue&type=script&lang=js&"
export * from "./creditwait.vue?vue&type=script&lang=js&"
import style0 from "./creditwait.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports